import { connectResources, customResource } from '@ds-frontend/resource'
import get from 'lodash/get'
import { withRouter } from 'next/router'
import { connect } from 'react-redux'
import { compose } from 'redux'

import HeaderQuoteContainer from './HeaderQuoteContainer'


function quoteRequest(API, params, { signal }) {
  return Promise.all(params.options.map(option => (
    API.get(`api/v2/public/quotes/${params.quote}/options/${option.id}`, {}, { signal })
  )))
}

export default compose(
  withRouter,
  connectResources({
    endpoint: 'api/v2/public/quotes/:uuid',
    namespace: 'quoteList',
  }),
  connect(state => ({
    aboutLink: get(state, 'cmsInfo.data.about_bl_slug', {}),
    options: get(state, 'quoteList.data.options', []),
  })),
  customResource(quoteRequest)({
    namespace: 'quotePrint',
    reducer: 'replace',
  }),
)(HeaderQuoteContainer)
